import Axios from 'axios';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const api = Axios.create({
  baseURL: publicRuntimeConfig.API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    const { CF_ACCESS_CLIENT_ID, CF_ACCESS_CLIENT_SECRET } = publicRuntimeConfig;
    if (CF_ACCESS_CLIENT_ID && CF_ACCESS_CLIENT_SECRET) {
      config.headers['CF-Access-Client-Id'] = CF_ACCESS_CLIENT_ID;
      config.headers['CF-Access-Client-Secret'] = CF_ACCESS_CLIENT_SECRET;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
